import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0907Model } from './kymw0907.model';
import { KYMW0907InputModel } from './vo/kymw0907-input.model';
import { KYMW0907OutputModel } from './vo/kymw0907-output.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { GetOrderNumQuotaCodeListService } from '../kymw0900/api-services/get-order-num-quota-code-list.service';
import { GetCodeListService } from '../../kymw02/api-services/get-code-list.service';
import { GetNvalDetailIdResponse, GetNvalDetailIdService } from './api-services/get-nval-detail-id.service';
import { VersatileComboBoxComponent } from '../../kymw02/combo-box/versatile-combo-box/versatile-combo-box.component';

/**
 * 1物N価媒体プロモーション設定画面を管理するクラス
 *
 * @export KYMW0907Component
 * @class KYMW0907Component
 */
@Component({
  selector: 'app-kymw0907',
  templateUrl: 'kymw0907.component.html',
  styleUrls: ['kymw0907.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0907Component extends PlessViewHelperSub implements OnInit {
  param: any;
  setKYMW0907Parameter: Function;
  kymw0907Model: KYMW0907Model = new KYMW0907Model();
  
  // 取扱可能生協
  public enableCoopList = [];

  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VersatileComboBoxComponent;
  
  closeFunction: Function;

  isComposing = false;

  /**
   *Creates an instance of KYMW0907Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0907Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getOrderNumQuotaCodeListService: GetOrderNumQuotaCodeListService,
    private getCodeListService: GetCodeListService,
    private getNvalDetailIdService: GetNvalDetailIdService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0907';
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   */
  public setInterfaceParam(param: KYMW0907InputModel): void {
    // kymw0900から値を受け取る
    this.setParam(param);
    
    if (this.isAddMode()) {
      this.kymw0907Model.registFlg = '1';
      this.kymw0907Model.itemRelatedCoop_CoopTab = param.itemRelatedCoop_CoopTab;

      // 初期値設定
      // 注文コード割当コードリスト取得（媒体初期値選択済みのため）
      const orderNumQuotaCodeVO = {
        orderCode: this.kymw0907Model.orderCode,
        pCode: this.kymw0907Model.pCode,
        getType: '1物N価媒体',
        mediumType: this.kymw0907Model.mediumType,
      };
      this.getOrderNumQuotaCodeListService.execute(orderNumQuotaCodeVO, (data) => {
        this.kymw0907Model.orderNumQuotaCodeList = data;
        this.kymw0907Model.orderNumQuotaCode = this.kymw0907Model.orderNumQuotaCodeList[0]?.OrderNumQuotaCode;
      });

      // 1物N価詳細区分リストを取得
      this.getCodeListService.execute('ctp113', '', this.kymw0907Model, 'nvalDetailDevList', ()=>{
        this.kymw0907Model.nvalDetailDev = this.kymw0907Model.nvalDetailDevList[0]?.Reserve1;
      }, null, this.kymw0907Model.mediumType);
      // 商品企画担当区分の初期値
      this.kymw0907Model.shkkktantKb = '2';
      // 供給単価の初期値
      this.kymw0907Model.supplyPriceStandard = param.supplyPriceStandard;

      // 価格パターン「0: 通常」に対応する供給単価の表示、値引き後供給単価の計算
      this.eventPricePattern_CHANGEHandler();

      // ※「追加」モードでパラメータ設定のために実行するメソッドは、
      // 「詳細」モードでparam.emptyDetailFlgがTRUE（＝空のデータに対して「詳細」モードでデータを開いたとき）の場合にも実行する。
      // 「1物N価詳細情報ID」「媒体」「アイテムコード」以外は「追加」時と同じように値を格納をするため。

    } else if (this.isDetailMode() || this.isReadOnlyMode()) {
      // kymw0900から値を受け取る
      this.kymw0907Model.nvalDetailId = param.nvalDetailId;
      this.kymw0907Model.orderNumQuotaCodeList = param.nvalOrderNumQuotaCodeList; // 注文コード割当リスト
      this.kymw0907Model.orderNumQuotaCode = param.nvalOrderNumQuotaCode;
      this.kymw0907Model.orderNum = param.orderNum;
      this.kymw0907Model.nvalDetailDevList = param.nvalDetailDevList;
      this.kymw0907Model.nvalDetailDev = param.nvalDetailDev;
      this.kymw0907Model.discountType = param.discountType;
      this.kymw0907Model.discountUnitPrice = param.discountUnitPrice;
      this.kymw0907Model.discountRate = param.discountRate;
      this.kymw0907Model.supplyPriceStandard = param.supplyPriceStandard;
      this.kymw0907Model.discountSupplyUnitPrice = param.discountSupplyUnitPrice;
      this.kymw0907Model.selectPricePattern = param.pricePattern;
      this.kymw0907Model.remarks = param.remarks;
      // 追加フラグ：
      // 注文コード割当コードが存在すれば、企画商品1物N価媒体基本情報テーブルの「更新」処理を行う
      // 注文コード割当コードが存在していなければ（遷移元の一覧で空白状態）、企画商品1物N価媒体基本情報テーブルの「登録」処理を行う
      this.kymw0907Model.registFlg = !PlessViewUtilsSub.isEmpty(param.nvalOrderNumQuotaCode) ? param.registFlg : '1';
      this.kymw0907Model.deleteFlg = param.deleteFlg;

      // 以下セレクトボックスを非活性にする。	
      // ・媒体
      // ・アイテムコード
      this.kymw0907Model.mediumTypeListDisable = true;
      this.kymw0907Model.itemCodeListDisable = true;
    }
    // 全選択チェック
    this.setCoopAllCheck();

    // kymw0900で空のデータに対して「詳細」で開いた場合
    if (param.emptyDetailFlg) {
      // 価格パターン「0: 通常」に対応する供給単価の表示、値引き後供給単価の計算
      this.eventPricePattern_CHANGEHandler();
    }
  }

  /**
   * 画面モード問わず設定される項目をセット
   * 
   * @param param 
   */
  private setParam(param: KYMW0907InputModel) {
    this.kymw0907Model.mode = param.mode;
    this.kymw0907Model.coopSupplyPriceList = param.coopSupplyPriceList;
    this.kymw0907Model.orderCode = param.orderCode;
    this.kymw0907Model.pCode = param.pCode;
    this.kymw0907Model.coopInfoItemCode = param.coopInfoItemCode;
    this.kymw0907Model.mediumTypeList = param.mediumTypeList;
    this.kymw0907Model.mediumType = param.mediumType;
    this.kymw0907Model.itemCodeList = param.itemCodeList;
    this.kymw0907Model.shkkktantKb = param.shkkktantKb;
    this.kymw0907Model.selectedItemCode = param.selectedItemCode;
    this.kymw0907Model.nvalPromotionGoodsName = param.nvalPromotionGoodsName;
    this.kymw0907Model.nvalPromotionGoodsNameKana = param.nvalPromotionGoodsNameKana;
    this.kymw0907Model.nvalPromotionStandardName = param.nvalPromotionStandardName;
    this.kymw0907Model.nvalPromotionStandardNameKana = param.nvalPromotionStandardNameKana;
    this.kymw0907Model.usePrefecture1Flg = param.usePrefecture1Flg;
    this.kymw0907Model.coopIBDisable = param.coopIBDisable;
    this.kymw0907Model.usePrefecture2Flg = param.usePrefecture2Flg;
    this.kymw0907Model.coopTODisable = param.coopTODisable;
    this.kymw0907Model.usePrefecture3Flg = param.usePrefecture3Flg;
    this.kymw0907Model.coopGUDisable = param.coopGUDisable;
    this.kymw0907Model.usePrefecture4Flg = param.usePrefecture4Flg;
    this.kymw0907Model.coopTIDisable = param.coopTIDisable;
    this.kymw0907Model.usePrefecture5Flg = param.usePrefecture5Flg;
    this.kymw0907Model.coopSADisable = param.coopSADisable;
    this.kymw0907Model.usePrefecture6Flg = param.usePrefecture6Flg;
    this.kymw0907Model.coopTKDisable = param.coopTKDisable;
    this.kymw0907Model.usePrefecture7Flg = param.usePrefecture7Flg;
    this.kymw0907Model.coopNADisable = param.coopNADisable;
    this.kymw0907Model.usePrefecture8Flg = param.usePrefecture8Flg;
    this.kymw0907Model.coopNIDisable = param.coopNIDisable;
  }

  /**
   * 追加モードか判定
   */
  public isAddMode(): boolean {
    return this.kymw0907Model.mode === KYMW0907InputModel.MODO_ADD;
  }

  /**
   * 詳細モードか判定
   */
  public isDetailMode(): boolean {
    return this.kymw0907Model.mode === KYMW0907InputModel.MODO_DETAIL;
  }

  /**
   * 閲覧モードか判定
   */
  public isReadOnlyMode(): boolean {
    return this.kymw0907Model.mode === KYMW0907InputModel.MODO_READ_ONLY;
  }

  /**
   * 媒体区分イベントリスナ
   */
  public mediumType_CHANGEHandler(): void {
    // 注文コード割当一覧取得処理を呼び出し、取得した情報を注文コード割当コードに反映する
    const orderNumQuotaCodeVO = {
      orderCode: this.kymw0907Model.orderCode,
      pCode: this.kymw0907Model.pCode,
      getType: '1物N価媒体',
      mediumType: this.kymw0907Model.mediumType,
    };
    this.getOrderNumQuotaCodeListService.execute(orderNumQuotaCodeVO, (data) => {
      this.kymw0907Model.orderNumQuotaCodeList = data;
    });

    // 1物N価詳細区分リストを取得
    this.getNvalDetailDevList(this.kymw0907Model.mediumType);
  }

  /**
   * 1物N価詳細区分リスト取得リスナ（CodeDiv:ctp113、CodeValue:mediumType）
   */
  public getNvalDetailDevList(mediumType: string, successFunc?: () => void): void {
    // コード一覧取得処理を呼び出し、取得した情報を1物N価詳細区分に反映する
    this.getCodeListService.execute('ctp113', '', this.kymw0907Model, 'nvalDetailDevList', successFunc, null, mediumType);
  }

  /**
   * 共通イベントリスナ
   * 特定の処理がないイベントハンドラで使用、更新フラグを立てる
   */
  public common_CHANGEHandler(): void {
    this.kymw0907Model.isEdited = true;
  }

  /**
   * アイテムコードイベントリスナ
   */
  public eventItemCode_CHANGEHandler(): void {
    // ＜ON/OFF制御＞
    // 選択したアイテムコードが「会員」タブで選択されている場合、チェックボックスON・選択されていない場合チェックボックスOFF（活性状態）
    const checkedCoop = this.kymw0907Model.coopInfoItemCode.find(_ => _.itemCode === this.kymw0907Model.selectedItemCode);
    if (checkedCoop) {
      const coopInfoItemCodeList = checkedCoop.coopCode;
      // 選択したアイテムコード（リストの一つ目）が会員タブで選択されている場合、その生協にチェックを入れる
      this.kymw0907Model.usePrefecture1Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_IB);
      this.kymw0907Model.usePrefecture2Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_TO);
      this.kymw0907Model.usePrefecture3Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_GU);
      this.kymw0907Model.usePrefecture4Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_TI);
      this.kymw0907Model.usePrefecture5Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_SA);
      this.kymw0907Model.usePrefecture6Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_TK);
      this.kymw0907Model.usePrefecture7Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_NA);
      this.kymw0907Model.usePrefecture8Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_NI);
    } else {
      this.kymw0907Model.usePrefecture1Flg = false;
      this.kymw0907Model.usePrefecture2Flg = false;
      this.kymw0907Model.usePrefecture3Flg = false;
      this.kymw0907Model.usePrefecture4Flg = false;
      this.kymw0907Model.usePrefecture5Flg = false;
      this.kymw0907Model.usePrefecture6Flg = false;
      this.kymw0907Model.usePrefecture7Flg = false;
      this.kymw0907Model.usePrefecture8Flg = false;
    }
    this.eventPricePattern_CHANGEHandler();
  }

  /**
   * 値引区分イベントリスナ
   */
  public discountType_CHANGEHandler(): void {
    this.kymw0907Model.isEdited = true;
    this.kymw0907Model.discountRate = '';
    this.kymw0907Model.discountUnitPrice = '';
    this.kymw0907Model.discountSupplyUnitPrice = this.kymw0907Model.supplyPriceStandard;
  }

  /**
   * 計算イベントリスナ
   */
  public eventCalcDiscountSupplyPrice_Handler(): void {
    if (this.kymw0907Model.discountType === '1') {
      this.eventDiscountUnitPrice_CHANGEHandler();
    } else if (this.kymw0907Model.discountType === '2') {
      this.eventDiscountRate_CHANGEHandler();
    } else {
      this.kymw0907Model.discountSupplyUnitPrice = this.kymw0907Model.supplyPriceStandard; 
    }
  }

  /**
   * 値引単価イベントリスナ
   */
  public eventDiscountUnitPrice_CHANGEHandler(): void {
    this.kymw0907Model.isEdited = true;
    this.kymw0907Model.discountSupplyUnitPrice = String(Number(this.kymw0907Model.supplyPriceStandard) - Number(this.kymw0907Model.discountUnitPrice));
  }

  /**
   * 値引率イベントリスナ
   */
  public eventDiscountRate_CHANGEHandler(): void {
    this.kymw0907Model.isEdited = true;
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.discountRate) || this.kymw0907Model.discountRate === 'blankVal') {
      // 値引率未選択の場合は供給単価をそのまま表示する
      this.kymw0907Model.discountSupplyUnitPrice = this.kymw0907Model.supplyPriceStandard;
    } else {
      // 小数点以下切り上げ
      this.kymw0907Model.discountSupplyUnitPrice = String(Math.ceil(Number(this.kymw0907Model.supplyPriceStandard) - (Number(this.kymw0907Model.supplyPriceStandard) / 100 * Number(this.kymw0907Model.discountRate))));
    }
  }

  /**
   * 価格パターン変更時のイベント
   */
  public eventPricePattern_CHANGEHandler(): void {
    // 選択した価格パターンに対応する価格を値引前供給単価に設定後、値引後供給単価を再計算
    const targetItemSupplyList = this.kymw0907Model.coopSupplyPriceList.find(_ => _.ItemCode === this.kymw0907Model.selectedItemCode);
    let tempSupplyPrice = '';
    if (targetItemSupplyList) {
      switch (this.kymw0907Model.selectPricePattern) {
        // ①【0:通常】の場合
        case '0':
          tempSupplyPrice = targetItemSupplyList.SupplyPriceStandard.toString();
          break;
        // ②【1:特価１】の場合
        case '1':
          tempSupplyPrice = targetItemSupplyList.SupplyPriceSpecial1.toString();
          break;
        // ③【2:特価２】の場合
        case '2':
          tempSupplyPrice = targetItemSupplyList.SupplyPriceSpecial2.toString();
          break;
        // ④【3:特価３】の場合
        case '3':
          tempSupplyPrice = '';
          break;
      }
    }
    // 値引前供給単価を設定
    this.kymw0907Model.supplyPriceStandard = tempSupplyPrice;
    this.eventCalcDiscountSupplyPrice_Handler();
  }

  /**
   * 全選択チェックボックス制御
   */
  public setCoopAllCheck(): void {
    // チェックボックスのうち、活性のものをリストに格納
    let enableCheckList = [];
    // 活性である場合、チェック可否を格納
    if (!this.kymw0907Model.coopIBDisable) {
      enableCheckList.push(this.kymw0907Model.usePrefecture1Flg);
    }
    if (!this.kymw0907Model.coopTODisable) {
      enableCheckList.push(this.kymw0907Model.usePrefecture2Flg);
    }
    if (!this.kymw0907Model.coopGUDisable) {
      enableCheckList.push(this.kymw0907Model.usePrefecture3Flg);
    }
    if (!this.kymw0907Model.coopTIDisable) {
      enableCheckList.push(this.kymw0907Model.usePrefecture4Flg);
    }
    if (!this.kymw0907Model.coopSADisable) {
      enableCheckList.push(this.kymw0907Model.usePrefecture5Flg);
    }
    if (!this.kymw0907Model.coopTKDisable) {
      enableCheckList.push(this.kymw0907Model.usePrefecture6Flg);
    }
    if (!this.kymw0907Model.coopNADisable) {
      enableCheckList.push(this.kymw0907Model.usePrefecture7Flg);
    }
    if (!this.kymw0907Model.coopNIDisable) {
      enableCheckList.push(this.kymw0907Model.usePrefecture8Flg);
    }
    
    // すべてのチェックボックスが活性でONの場合のみ全選択チェックボックスをON
    let flg = true;
    for (const checked of enableCheckList) {
      if (!checked) {
        flg = false;
        break;
      }
    }
    this.kymw0907Model.allCoop = flg;
  }

  /**
   * 全選択チェックイベントリスナ
   */
  public eventAllCoop_CLICKHandler(): void {
    const flg = this.kymw0907Model.allCoop;
    this.kymw0907Model.usePrefecture1Flg = this.kymw0907Model.coopIBDisable ? false : flg;
    this.kymw0907Model.usePrefecture2Flg = this.kymw0907Model.coopTODisable ? false : flg;
    this.kymw0907Model.usePrefecture3Flg = this.kymw0907Model.coopGUDisable ? false : flg;
    this.kymw0907Model.usePrefecture4Flg = this.kymw0907Model.coopTIDisable ? false : flg;
    this.kymw0907Model.usePrefecture5Flg = this.kymw0907Model.coopSADisable ? false : flg;
    this.kymw0907Model.usePrefecture6Flg = this.kymw0907Model.coopTKDisable ? false : flg;
    this.kymw0907Model.usePrefecture7Flg = this.kymw0907Model.coopNADisable ? false : flg;
    this.kymw0907Model.usePrefecture8Flg = this.kymw0907Model.coopNIDisable ? false : flg;
  }

  /**
   * 「閉じる」
   */
  public eventClose_CLICKHandler(): void {
    // 編集が行われている場合、メッセージを表示
    if (this.kymw0907Model.isEdited) {
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['1物N価媒体プロモーション設定'], (closeEvent: number) => {
        if (closeEvent === PlessAlert.Yes) {
          this.closeFunction();
        }
      });
    } else {
      this.closeFunction();
    }
  }

  /**
   * 設定ボタンを押下したときに呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSet_CLICKHandler(): void {
    if (!this.validate()) {
      return;
    }

    // 1物N価プロモーション情報設定モーダルの呼び出し元確認
    if (this.isAddMode()) {
      // 追加ボタン押下より、遷移した場合、1物N価約詳細情報ID取得を行う
      this.getNvalDetailIdService.execute((data: GetNvalDetailIdResponse) =>{
        this.kymw0907Model.nvalDetailId = data.NvalDetailId;
        // 編集した内容で、1物N価媒体プロモーション設定情報一覧に行を追加する
        this.setParamsAndClose();
      });
    } else if (this.isDetailMode()) {
      // 編集した内容で、1物N価媒体プロモーション設定情報一覧の内容を更新する
      this.setParamsAndClose()
    }
  }

  /**
   * 値をセットしてモーダルを閉じるメソッド
   */
  public setParamsAndClose(): void {
    // 親画面に反映
    const vo = new KYMW0907OutputModel();
    vo.nvalDetailId = this.kymw0907Model.nvalDetailId;
    vo.orderCode = this.kymw0907Model.orderCode;
    vo.mediumType = this.kymw0907Model.mediumType;
    vo.mediumName = this.kymw0907Model.mediumTypeList.find(_ => _.MediumType === this.kymw0907Model.mediumType)?.MediumName || '';
    vo.selectedItemCode = this.kymw0907Model.selectedItemCode;
    vo.nvalOrderNumQuotaCode = this.kymw0907Model.orderNumQuotaCode;
    vo.orderNum = this.kymw0907Model.orderNum;
    vo.nvalDetailDev = this.kymw0907Model.nvalDetailDev;
    vo.shkkktantKb = this.kymw0907Model.shkkktantKb;
    vo.nvalPromotionGoodsName = this.kymw0907Model.nvalPromotionGoodsName;
    vo.nvalPromotionGoodsNameKana = this.kymw0907Model.nvalPromotionGoodsNameKana;
    vo.nvalPromotionStandardName = this.kymw0907Model.nvalPromotionStandardName;
    vo.nvalPromotionStandardNameKana = this.kymw0907Model.nvalPromotionStandardNameKana;
    vo.discountType = this.kymw0907Model.discountType;
    vo.discountUnitPrice = this.kymw0907Model.discountUnitPrice;
    vo.discountRate = this.kymw0907Model.discountRate;
    vo.supplyPriceStandard = this.kymw0907Model.supplyPriceStandard;
    vo.discountSupplyUnitPrice = this.kymw0907Model.discountSupplyUnitPrice;
    vo.pricePattern = this.kymw0907Model.selectPricePattern;
    vo.allCoop = this.kymw0907Model.allCoop ? '1' : '0';
    vo.usePrefecture1Flg = this.kymw0907Model.usePrefecture1Flg ? '1' : '0';
    vo.usePrefecture2Flg = this.kymw0907Model.usePrefecture2Flg ? '1' : '0';
    vo.usePrefecture3Flg = this.kymw0907Model.usePrefecture3Flg ? '1' : '0';
    vo.usePrefecture4Flg = this.kymw0907Model.usePrefecture4Flg ? '1' : '0';
    vo.usePrefecture5Flg = this.kymw0907Model.usePrefecture5Flg ? '1' : '0';
    vo.usePrefecture6Flg = this.kymw0907Model.usePrefecture6Flg ? '1' : '0';
    vo.usePrefecture7Flg = this.kymw0907Model.usePrefecture7Flg ? '1' : '0';
    vo.usePrefecture8Flg = this.kymw0907Model.usePrefecture8Flg ? '1' : '0';
    vo.remarks = this.kymw0907Model.remarks;
    vo.registFlg = this.kymw0907Model.registFlg;
    vo.deleteFlg = this.kymw0907Model.deleteFlg;
    this.setKYMW0907Parameter(vo);

    this.closeFunction();
  }

  /**
   * 設定ボタン押下時のバリデーション
   */
  private validate(): boolean {
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.selectedItemCode)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['アイテムコード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.mediumType)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['媒体']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.orderNumQuotaCode)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['注文コード割当コード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.nvalDetailDev)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['1物N価詳細区分']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.shkkktantKb)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['商品企画担当区分']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.nvalPromotionGoodsName)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['専用商品名']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.nvalPromotionGoodsNameKana)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['専用商品名(カナ)']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.nvalPromotionStandardName)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['専用規格名']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.nvalPromotionStandardNameKana)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['専用規格名(カナ)']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.discountType)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['値引区分']);
      return false;
    }
    if (this.kymw0907Model.discountType === '1') {
      // 値引区分で値引単価が指定されている場合、値引単価は必須
      if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.discountUnitPrice)) {
        this.dialogServiceSub.openAlertGetMessage('W0001', ['値引単価']);
        return false;
      }
    } else if (this.kymw0907Model.discountType === '2') {
      // 値引区分で値引率が指定されている場合、値引率は必須
      if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.discountRate) || this.kymw0907Model.discountRate === 'blankVal') {
        this.dialogServiceSub.openAlertGetMessage('W0001', ['値引率']);
        return false;
      }
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0907Model.supplyPriceStandard)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['供給単価']);
      return false;
    }

    // 値引情報の正当性チェックを行う
    if (this.kymw0907Model.discountType === '1') {
      // 値引区分が「1：単価指定」かつ値引単価が0の場合
      if (Number(this.kymw0907Model.discountUnitPrice) === 0) {
        this.dialogServiceSub.openAlertGetMessage('E0577');
        return false;
      }
      // 値引区分が「1：単価指定」かつ値引単価 > 供給単価の場合
      if (Number(this.kymw0907Model.discountUnitPrice) > Number(this.kymw0907Model.supplyPriceStandard)) {
        this.dialogServiceSub.openAlertGetMessage('E0578', ['値引単価には供給単価を超える金額']);
        return false;
      }
    } else if (this.kymw0907Model.discountType === '2') {
      // 値引区分が「2：率指定」かつ値引率が1～100の範囲外の場合
      if (!(Number(this.kymw0907Model.discountRate) > 0 && Number(this.kymw0907Model.discountRate) <= 100)) {
        this.dialogServiceSub.openAlertGetMessage('E0579');
        return false;
      }
    }

    // 利用都県の正当性チェックを行う
    if (!this.kymw0907Model.usePrefecture1Flg &&
      !this.kymw0907Model.usePrefecture2Flg &&
      !this.kymw0907Model.usePrefecture3Flg &&
      !this.kymw0907Model.usePrefecture4Flg &&
      !this.kymw0907Model.usePrefecture5Flg &&
      !this.kymw0907Model.usePrefecture6Flg &&
      !this.kymw0907Model.usePrefecture7Flg &&
      !this.kymw0907Model.usePrefecture8Flg) {
      // 利用都県のチェックボックスが全てOFFの場合
      this.dialogServiceSub.openAlertGetMessage('E0105', ['利用都県']);
      return false;
    }
    return true;
  }

  /**
   * 注文コード割当変更時のメソッド
   */
  public nvalOrderNumQuotaCode_CHANGEHandler(): void {
    // 1物N価媒体注文コードの値を検証する
    if (!PlessViewUtilsSub.isEmpty(this.kymw0907Model.orderNum)) {
      // NULLではない、かつ空文字ではない場合、クリアする
      this.kymw0907Model.orderNum = '';
    }
  }

  /**
   * 専用商品名(カナ)の入力から半角カンマを削除
   */
  public eventNvalPromotionGoodsNameKana_deleteCommaHandler(): void {
    this.kymw0907Model.nvalPromotionGoodsNameKana = this.kymw0907Model.nvalPromotionGoodsNameKana.replace(/,/g, '');
  }

  /**
   * 専用規格名(カナ)の入力から半角カンマを削除
   */
  public eventNvalPromotionStandardNameKana_deleteCommaHandler(): void {
    this.kymw0907Model.nvalPromotionStandardNameKana = this.kymw0907Model.nvalPromotionStandardNameKana.replace(/,/g, '');
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }
}
